import type { ReactNode } from 'react';
import clsx from 'clsx';
import { OriginLink } from '@/lib/origin';

/**
 * A Home stat that opens the list it counts. A real link (keyboard, middle-click, copy link), with an underline and
 * tint on hover and the standard focus ring, named for screen readers ("View 4 open issues").
 */
export function StatLink({ to, label, children, className, stat }: { to: string; label: string; children: ReactNode; className?: string; stat: string }) {
  return (
    <OriginLink to={to} aria-label={label} title={label} data-testid="home-stat" data-stat={stat}
      className={clsx('group/stat -m-1 block rounded-lg p-1 decoration-2 underline-offset-4 transition hover:bg-slate-50 hover:underline dark:hover:bg-slate-800/60', className)}>
      {children}
    </OriginLink>
  );
}
